// A wrapper around axios
import axios from 'axios';

const api = axios.create({
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getPortfolioData = (lang) => {
  // return api.get('/en/api/product-categories');
  return api.get(`/${lang}/api/product-categories`);
};

export const getContactPersons = (lang) => {
  return api.get(`/${lang}/api/contact-persons`);
};
